import { WalletConnect as WalletConnectV2 } from "@web3-react/walletconnect-v2";

import { MAINNET_CHAINS } from "../utils/chains";
import { initializeConnector } from "@web3-react/core";

const [mainnet, ...optionalChains] = Object.keys(MAINNET_CHAINS).map(Number);

export const [walletConnectV2, hooks] = initializeConnector(
  (actions) =>
    new WalletConnectV2({
      actions,
      options: {
        projectId: "56e76179389975627afbbb8fdb7d6712",
        chains: [1],
        optionalChains: [4],
        showQrModal: true,
      },
      timeout: 10000,
      onError: (err) => {
        console.log("erron in connector::::", err);
      },
    })
);
